@if (displayDisclaimer && userService.loggedUser) {
  <div class="disclaimer-container" data-cy="open-order-disclaimer">
    <div class="disclaimer-layout">
      <div class="disclaimer-text">
        {{ 'disclaimer.text' | translate }} <a routerLink="/money">{{ 'menu.moneyAndTransactions' | translate }}</a>.
      </div>
      <button class="button-close" (click)="closeDisclaimer()" data-cy="close-order-disclaimer">
        <svg-icon src="assets/icons/cross.svg" [svgStyle]="{ 'height.px':18 }"></svg-icon>
      </button>
    </div>
  </div>
}